export default {
      id: "icon_guide-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#icon_guide",
      toString: function () {
        return this.url;
      }
    }